<p>
  Потребителското име (още наричано „никнейм“) е вашата публична идентичност в платформата – то се показва до вашите
  обяви, коментари, отзиви и в самия профил.
</p>
<h6 class="mt-3">Възможна ли е промяна?</h6>
<p>
  По съображения за сигурност и за предотвратяване на злоупотреби (като подвеждаща идентичност или заобикаляне на
  блокиране),
  <strong>смяната на потребителско име не е възможна директно през сайта</strong>.
</p>
<h6 class="mt-3">Как да подадете заявка за промяна?</h6>
<p class="mb-1">
  Ако желаете да смените своето потребителско име, е необходимо да изпратите запитване чрез
  <a class="text-decoration-none"
     [routerLink]="[appRoutes.root, appRoutes.contactUs]">
    формата за контакт,
  </a> като посочите:
</p>
<ul>
  <li>Текущото си потребителско име</li>
  <li>Желаното ново потребителско име</li>
  <li>Кратко обяснение за причината</li>
</ul>
<h6 class="mt-3">Какво следва?</h6>
<p>
  След подаване на заявката, нашият екип ще я прегледа в рамките на <strong>2 работни дни</strong>. Ако желаното име е
  свободно и няма основания за отказ, промяната ще бъде извършена и ще получите потвърждение по имейл.
</p>
<div class="alert alert-primary m-0">
  <strong>Съвет:</strong> Изберете никнейм, който отговаря на вашата идентичност и е лесно разпознаваем. След одобрение,
  той ще се актуализира във всички ваши обяви и действия в платформата.
</div>
